<p-toast></p-toast>

<h2 class="page-title">
  {{ "i18n.domain.privacy-policy.overview.title" | translate }}
</h2>

<div class="data-table">
  <p-toolbar>
    <ng-template pTemplate="left">
      <p-button
        label="{{ 'i18n.domain.privacy-policy.overview.add' | translate }}"
        icon="pi pi-file-edit"
        (onClick)="openNew()"
      ></p-button>
    </ng-template>
  </p-toolbar>

  <p-table
    [value]="data"
    [rows]="pagedQuery.pageSize"
    [paginator]="true"
    [rowHover]="true"
    dataKey="id"
    [lazy]="true"
    (onPage)="onPageChange($event)"
    (onSort)="onSort($event)"
    [customSort]="true"
    sortField="version"
    [sortOrder]="-1"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Privacy Policies"
    [showCurrentPageReport]="true"
    [totalRecords]="totalNoOfRecords"
    [rowsPerPageOptions]="pagedQuery.getPageSizes()"
    styleClass="dt-grid"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{ "i18n.domain.privacy-policy.fields.name" | translate }}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="version" class="dt-num">
          {{ "i18n.domain.privacy-policy.fields.version" | translate }}
          <p-sortIcon field="version"></p-sortIcon>
        </th>
        <th pSortableColumn="forceReacceptance" class="dt-center">
          {{
            "i18n.domain.privacy-policy.fields.forceReacceptance" | translate
          }}
          <p-sortIcon field="forceReacceptance"></p-sortIcon>
        </th>
        <th pSortableColumn="createdOn">
          {{ "i18n.domain.privacy-policy.fields.createdOn" | translate }}
          <p-sortIcon field="createdOn"></p-sortIcon>
        </th>
        <th pSortableColumn="modifiedOn">
          {{ "i18n.domain.privacy-policy.fields.modifiedOn" | translate }}
          <p-sortIcon field="modifiedOn"></p-sortIcon>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-policy>
      <tr>
        <td>{{ policy.name }}</td>
        <td class="dt-num">{{ policy.version }}</td>
        <td class="dt-center">
          <p-tag
            [value]="policy.forceReacceptance ? 'Yes' : 'No'"
            [severity]="policy.forceReacceptance ? 'success' : 'danger'"
          ></p-tag>
        </td>
        <td>{{ policy.createdOn | date: "short" }}</td>
        <td>{{ policy.modifiedOn | date: "short" }}</td>
        <td>
          <div class="grid-commands">
            <p-button
              icon="pi pi-file-edit"
              [rounded]="true"
              [outlined]="true"
              severity="success"
              (onClick)="editItem(policy)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">No Privacy Policies found</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="itemDialog"
    [style]="{ width: '900px', height: '600px' }"
    [modal]="true"
    [contentStyle]="{ 'max-height': '500px', overflow: 'auto' }"
    [draggable]="false"
    [resizable]="false"
    styleClass="p-fluid"
  >
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <span class="dialog-title">
          {{ "i18n.domain.privacy-policy.overview.add" | translate }}
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <form [formGroup]="form" class="policy-form">
        <div class="field">
          <label for="name">
            {{ "i18n.domain.privacy-policy.fields.name" | translate }}
          </label>
          <input
            id="name"
            type="text"
            pInputText
            formControlName="Name"
            [readonly]="isReadOnly"
          />
        </div>

        <div class="field">
          <label for="version">
            {{ "i18n.domain.privacy-policy.fields.version" | translate }}
          </label>
          <input
            id="version"
            type="text"
            pInputText
            formControlName="Version"
            [readonly]="isReadOnly"
          />
        </div>

        <div class="field checkbox-field">
          <p-checkbox
            formControlName="ForceReacceptance"
            inputId="forceReacceptance"
            binary="true"
            [disabled]="isReadOnly"
          ></p-checkbox>
          <label for="forceReacceptance">
            {{
              "i18n.domain.privacy-policy.fields.forceReacceptance" | translate
            }}
          </label>
        </div>

        <div class="field">
          <label for="policyContent">
            {{ "i18n.domain.privacy-policy.fields.policyContent" | translate }}
          </label>
          <p-editor
            id="policyContent"
            formControlName="PolicyContent"
            [style]="{ height: '400px', width: '100%' }"
            [readonly]="isReadOnly"
          ></p-editor>
        </div>
      </form>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-button
        label="{{ 'i18n.shared.cancel' | translate }}"
        icon="pi pi-times"
        [text]="true"
        (onClick)="hideDialog()"
      ></p-button>

      <p-button
        *ngIf="isReadOnly"
        label="{{ 'i18n.shared.amend' | translate }}"
        icon="pi pi-pencil"
        [text]="true"
        (onClick)="amendPolicy()"
      ></p-button>

      <p-button
        *ngIf="!isReadOnly"
        label="{{ 'i18n.shared.save' | translate }}"
        icon="pi pi-check"
        [text]="true"
        (onClick)="savePrivacyPolicy()"
        [disabled]="!form.valid || !form.dirty"
      ></p-button>
    </ng-template>
  </p-dialog>
</div>
